import { render, staticRenderFns } from "./ProductComponentUpdate.vue?vue&type=template&id=ca8e4e22&"
import script from "./ProductComponentUpdate.vue?vue&type=script&lang=ts&"
export * from "./ProductComponentUpdate.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports